import { useQuery } from "@tanstack/react-query";

import { getMaxThreadSizes } from "../api/filter";

export function useMaxThreadSizes(fastenerBrand?: string) {
  return useQuery<number[]>({
    queryKey: ["filter-options", "max-thread-sizes", fastenerBrand ?? null],
    queryFn: () => getMaxThreadSizes(fastenerBrand),
    staleTime: 5 * 60 * 1000,
  });
}
